import { ImageOff } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { useAuthedImageState } from './useAuthedImage';

interface Props {
  url: string | null;
  token: string | undefined;
  alt: string;
  className?: string;
  /** Was statt des Bildes steht, wenn es nicht geladen werden kann. */
  fallback?: ReactNode;
}

/**
 * `<img>` das seine Bytes per Bearer-Token laedt (siehe useAuthedImage). Bis dahin ein Skeleton;
 * scheitert das Laden, ein ruhiger Ersatz statt eines Schimmers, der nie aufhört.
 */
export function AuthedImage({ url, token, alt, className, fallback }: Props) {
  const { src, failed, broken } = useAuthedImageState(url, token);
  if (failed) {
    return (
      fallback ?? (
        <div
          className={cn('bg-sand text-fg-dim flex items-center justify-center', className)}
          aria-hidden
        >
          <ImageOff className="size-6" />
        </div>
      )
    );
  }
  if (!src) {
    return <div className={cn('bg-sand animate-pulse', className)} aria-hidden />;
  }
  return <img src={src} alt={alt} className={className} onError={broken} />;
}
